<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card>
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            />
            <b-col
              v-if="!isSuperAdmin"
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-button
                  v-b-modal.modal-role
                  variant="primary"
                  @click="statementGroup(addStatementGroup)"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_ADD_GROUP_STATEMENT') }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="roles"
          class="position-relative"
          :fields="tableFields"
          :items="statementGroupsData"
        >
          <template #cell(status)="data">
            <b-badge
              pill
              :variant="data.item.status === 1 ? 'success' : 'warning' "
            >
              {{ data.item.status === 1 ? 'Active' : 'InActive' }}
            </b-badge>
          </template>
          <template #cell(action)="data">
            <feather-icon
              v-b-modal.modal-role
              icon="EditIcon"
              @click="statementGroup(data.item)"
            />
            <feather-icon
              icon="Trash2Icon"
              style="margin-left: 15px; color: #ff3737;"
              @click="confirmation(data.item.id, data.item.title)"
            />
          </template>
        </b-table>
        <statement-groups-modal
          :get-statement-groups-data="editData"
          :get-statement-groups-options="statementGroupsOptions"
          :get-statement-ids="statementIds"
          :modal-loads="modalLoader"
          :show="!modalLoader"
          :reload-method="getStatementGroups"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BTable, BRow, BCol, BButton, BBadge,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import statementGroupsModal from './statementGroupsModal.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BRow,
    BCol,
    BButton,
    BBadge,
    statementGroupsModal,
  },
  data() {
    return {
      searchBy: 'All',
      loader: false,
      statementGroupsData: [],
      statementGroupsOptions: [],
      statementIds: [],
      editData: {},
      addStatementGroup: {
        id: 0,
        title: '',
        da_name: '',
        en_name: '',
        statement_ids: '',
        status: 1,
        user_id: JSON.parse(localStorage.getItem('userData')).data.id,
      },
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
      modalLoader: true,
      constants,
      isSuperAdmin: false,
    }
  },
  computed: {
    tableFields() {
      return [
        { key: 'id', sortable: true },
        { key: 'title', sortable: true, label: i18n.t('DEBTIA_TITLE') },
        { key: 'da_name', sortable: true, label: i18n.t('DEBTIA_DA_TITLE') },
        { key: 'en_name', sortable: true, label: i18n.t('DEBTIA_EN_TITLE') },
        { key: 'status', sortable: true, label: i18n.t('DEBTIA_STATUS') },
        { key: 'action', label: i18n.t('DEBTIA_ACTION') },
      ]
    },
  },
  created() {
    this.getStatementGroups()
    this.getStatementGroupsDropdown()
    this.actionColumn()
  },
  methods: {
    async getStatementGroups() {
      try {
        if (this.user_type === 'super-admin' || this.user_type === 'system-user') {
          this.isSuperAdmin = true
        } else {
          this.isSuperAdmin = false
        }
        this.loader = true
        const statementGroups = await axios.get(`${constants.baseUrl}/get-all-statement-groups`)
        this.loader = false
        if (statementGroups.status) {
          this.statementGroupsData = statementGroups.data.data.statement_groups
          this.loader = false
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
    async getStatementGroupsDropdown() {
      try {
        if (this.user_type === 'super-admin' || this.user_type === 'system-user') {
          this.isSuperAdmin = true
        } else {
          this.isSuperAdmin = false
        }
        this.loader = true
        const statementGroups = await axios.get(`${constants.baseUrl}/user-settings/get-statement-settings-dropdown`)
        this.loader = false
        if (statementGroups.data.status) {
          this.statementGroupsOptions = statementGroups.data.data
          statementGroups.data.data.forEach(element => {
            this.statementIds.push(element.value)
          })
          this.loader = false
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
    statementGroup(item) {
      this.modalLoader = true
      this.editData = item
      this.modalLoader = false
    },
    async deleteStatementGroup(id) {
      this.loader = true
      const statementGroup = await axios.get(`${constants.baseUrl}/delete-statement-group/${id}`)
      if (statementGroup.status) {
        this.getStatementGroups()
      }
      this.loader = false
    },
    confirmation(id, title) {
      // methodId
      const msg = 'DEBTIA_DELETION_MSG'
      const question = ` '${title}' ?`
      this.$swal({
        title: i18n.t('DEBTIA_CAUTION'),
        text: i18n.t(msg) + question,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.deleteStatementGroup(id)
        }
      })
    },
    actionColumn() {
      if (this.$ability.cannot(this.constants.action.permissionApiTokenEdit, this.constants.resource.apiToken) && this.$ability.cannot(this.constants.action.permissionApiTokenDelete, this.constants.resource.apiToken) && this.$ability.cannot(this.constants.action.permissionApiTokenRevoke, this.constants.resource.apiToken)) {
        this.tableFields.splice(4, 1)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.query-input{
  padding: 0px
}

.search_by_select .vs__dropdown-toggle{
  width: 160px;
}
</style>
